import { render, staticRenderFns } from "./11MedalManagement.vue?vue&type=template&id=c8471ae6&scoped=true&"
import script from "./11MedalManagement.vue?vue&type=script&lang=js&"
export * from "./11MedalManagement.vue?vue&type=script&lang=js&"
import style0 from "./11MedalManagement.vue?vue&type=style&index=0&id=c8471ae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8471ae6",
  null
  
)

export default component.exports